<!-- //
业务封装：侧边树
@auth xuyd
@date 2024-05-01
//-->
<template>
  <SideTree :load="getGroupList"
            :width="width"
            :editable="editable && checkPermission"
            :default-props="defaultProps"
            @save="handleGroupSaveNode"
            @up="handleGroupUpNode"
            @down="handleGroupDownNode"
            @delete="handleGroupDeleteNode"
            @change="handleGroupChange"
  />
</template>

<script>
import ApiDesignApi from '@/api/datasvc/apiDesign.api.js';
import SideTree from '@/components/SideTree';

export default {
  name: 'CompBizSideTree',
  components: {SideTree},
  data() {
    return {
      defaultProps: {children: 'children', label: 'name', countProp: 'apiCount'},
    };
  },
  props: {
    editable: {
      type: Boolean,
      default: false
    },
    permission: String,
    width: {
      type: Number,
      default: 200
    }
  },
  computed: {
    checkPermission() {
      const groupPermission = this.permission;
      return (this.$store.getters.permissions.includes('*:*:*')
          || this.$store.getters.permissions.includes(groupPermission));
    }
  },
  methods: {
    getGroupList() {
      return new Promise(resolve => {
        ApiDesignApi.selectGroupList().then((resp) => {
          // 需要跟节点
          let root = [{id: '0', parentId: '-1', name: '全部分组', apiCount: 0, children: []}];
          root.push(...resp.data);

          // 需要统计
          let treeList = this.$util.listToTreeWithStat(root, {
            idField: 'id',
            pidField: 'parentId',
            countField: this.defaultProps.countProp,
            virtualRoot: true
          });
          // console.log("----getGroupList---->",JSON.stringify(treeList));
          resolve(treeList);
        });
      });
    },
    // 组：添加/编辑节点
    handleGroupSaveNode(data, resolve) {
      // console.log("---handleGroupAddNode--->", data);
      ApiDesignApi.saveGroup(data).then(resp => {
        resolve(resp.data);
      })
    },
    // 组：上移
    handleGroupUpNode(data, resolve) {
      ApiDesignApi.upGroup(data).then(resp => {
        resolve(resp.data);
      });
    },
    // 组：下移
    handleGroupDownNode(data, resolve) {
      ApiDesignApi.downGroup(data).then(resp => {
        resolve(resp.data);
      });
    },
    // 组：删除
    handleGroupDeleteNode(data, resolve) {
      ApiDesignApi.deleteGroup(data).then(resp => {
        resolve(resp.data);
      });
    },
    // 查询
    handleGroupChange(data) {
      this.$emit('change', data);
    },
  }
}
</script>

<style lang="less" scoped>

</style>
